module.exports = __webpack_public_path__ + "img/icon_logo.a2487a13.png";